module.exports = __webpack_public_path__ + "img/1551754729.1d6d486c.svg";